// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      borderBottom: '1px solid #ddd',
    },
    borderTop: {
      borderTop: '2px solid #ddd',
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
    },
    hideDisplay: {
      visibility: 'hidden',
    },
    searchFormControl: {},
  }),
);

export default useStyles;
